import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Felanmalan = lazy(() => import("@/pages/info/Felanmalan"));

export const Route = createFileRoute("/felanmalan")({
  head: () => seoHead("/felanmalan", { description: "Har något slutat fungera på Elmarknad.se? Beskriv felet så rättar vi det så snabbt vi kan. Du får ett referensnummer direkt." }),
  component: () => <Felanmalan />,
});
